/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './deleteValues.defs.js'
export { main as default } from './deleteValues.defs.js'
